export default "__VITE_ASSET__C9M8380o__"